// 画面の切り替え（ハッシュ #/name?k=v）。各画面は mount で描き、戻り値の関数で後片付けする。
export type Cleanup = () => void;
export interface Screen {
  title: string;
  /** バトル等：スマホで下のタブを隠し、盤面を広く取る */
  full?: boolean;
  /** 左メニュー・タブで強調する項目 */
  nav?: string;
  mount(el: HTMLElement, params: URLSearchParams): void | Cleanup | Promise<void | Cleanup>;
}

const screens = new Map<string, Screen>();
export const register = (name: string, s: Screen) => screens.set(name, s);

let current: { name: string; cleanup: Cleanup | null; token: number } | null = null;
let token = 0;
let guard: ((name: string) => string | null) | null = null;
let after: ((name: string, s: Screen) => void) | null = null;

export function setGuard(fn: (name: string) => string | null) {
  guard = fn;
}
export function onRoute(fn: (name: string, s: Screen) => void) {
  after = fn;
}
/** 画面の mount が終わったとき（チュートリアルの案内など）。戻り値で外す */
const mountedFns = new Set<(name: string, el: HTMLElement, params: URLSearchParams) => void>();
export function onMounted(fn: (name: string, el: HTMLElement, params: URLSearchParams) => void) {
  mountedFns.add(fn);
  return () => mountedFns.delete(fn);
}

export function go(name: string, params: Record<string, string | number> = {}, replace = false) {
  const q = new URLSearchParams(Object.entries(params).map(([k, v]) => [k, String(v)])).toString();
  const hash = `#/${name}${q ? `?${q}` : ''}`;
  if (location.hash === hash) return void render();
  if (replace) {
    history.replaceState(null, '', hash);
    void render();
  } else location.hash = hash;
}

export function parse(): { name: string; params: URLSearchParams } {
  const m = /^#\/([\w-]+)(?:\?(.*))?$/.exec(location.hash);
  return { name: m?.[1] ?? 'top', params: new URLSearchParams(m?.[2] ?? '') };
}

export const currentName = () => current?.name ?? null;

export async function render() {
  let { name, params } = parse();
  const redirect = guard?.(name);
  if (redirect && redirect !== name) {
    name = redirect;
    history.replaceState(null, '', `#/${name}`);
  }
  const s = screens.get(name) ?? screens.get('top')!;
  current?.cleanup?.();
  const my = ++token;
  current = { name, cleanup: null, token: my };
  const el = document.getElementById('screen')!;
  el.innerHTML = '';
  el.className = `screen screen-${name}`;
  document.title = `${s.title}｜百鬼国盗`;
  after?.(name, s);
  const r = await s.mount(el, params);
  if (current?.token === my) current.cleanup = r ?? null;
  else r?.();
  el.focus({ preventScroll: true });
  if (current?.token === my) for (const f of mountedFns) f(name, el, params);
}

window.addEventListener('hashchange', () => void render());
